module.exports = __webpack_public_path__ + "img/arrow-right.ae09b573.svg";